<template>
  <api-errors 
    v-if="!!(errors || []).length"
    :errors="errors"
  />
  <div v-else>
    <div>
      <loading-bar v-if="awaitingApiResponse" />
      <v-row no-gutters>
        <v-autocomplete
          v-model="filterMap.serverId"
          :items="servers"
          item-text="name"
          item-value="id"
          label="Server"
          clearable
          hide-details
          class="px-3 pb-2"
        >
          <template #selection="{ item: server }">
            <server-initial-icon 
              v-bind="{server}"
              class="pr-2"
            />
            <div class="font-weight-bold">
              {{ server.name }}
            </div>
          </template>
          <template #item="{ item: server }">
            <server-initial-icon 
              v-bind="{server}"
              large
              class="pr-2"
            />
            <div class="font-weight-bold">
              {{ server.name }}
            </div>
          </template>
        </v-autocomplete>
      </v-row>
      <div v-if="assignmentsEmpty">
        <v-card class="pa-3 mx-2 mb-2 text-center font-weight-bold elevation-0">
          No Assignments Found...
        </v-card>
      </div>
      <div 
        v-else
        class="px-2 py-2"
      >
        <v-row 
          v-if="$vuetify.breakpoint.mdAndUp"
          no-gutters
          class="px-4"
        >
          <v-col 
            cols="4"
            lg="2"
          >
            Tables
          </v-col>
          <v-col 
            v-if="$vuetify.breakpoint.lgAndUp"
            cols="2"
          >
            Covers
          </v-col>
          <v-col cols="4">
            Reservee
          </v-col>
          <v-col 
            cols="4"
            class="text-right"
          >
            Server Assignment
          </v-col>
        </v-row>
        <template v-for="(reservations, serverId) in assignmentsMap">
          <assignment-card 
            v-for="reservation of reservations"
            :key="`server-${serverId}-reservation-${reservation.id}`"
            :server="serversMap[serverId]"
            :reservation="reservation"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AssignmentCard from './AssignmentCard'
import floorPlanHelpers from '../../mixins/floorPlanHelpers'
export default {
  name: 'AssignmentsTab',
  components: {AssignmentCard},
  mixins: [floorPlanHelpers],
  props: {
    location: Object,
    mealPeriod: Object,
    date: [Number, String],
  },
  data () {
    return {
      /**
       * * `result` returned from `diningGetServerAssigments`
       * @param {Map<DiningLocationTable.id, List<DiningServer>>} assignmentsMap 
       */
      assignmentsMap: {},
      /** List of all servers in club's database */
      servers: [],
      /** 
       * Map of filters to be applied to `assignmentsMap` query 
       * @see assignmentsMap
       */
      filterMap: {},
    }
  },
  computed: {
    /**
     * @see servers
     * @returns {Object} `servers` mapped by ID
     */
    serversMap () {
      return this.servers.reduce((acc, s) => {
        acc[s.id] = s
        return acc
      }, {}) ?? {}
    },
    /**
     * @see assignmentsMap
     * @returns {Boolean} IF the `assignmentsMap` for _every_ server is empty
     */
    assignmentsEmpty () {
      for (let serverId in this.assignmentsMap) {
        if (this.assignmentsMap[serverId]?.length) return false
      }
      return true
    }
  },
  mounted () {
    ['filterMap', 'mealPeriod.id'].forEach(w => this.$watch(w, this.getAssignments, {deep: typeof this[w] === 'object'}))
    this.getAssignments()
  },
  methods: {
    getAssignments () {
      this.awaitingApiResponse = true
      const commands = [
        {
          command: 'diningServer',
          load: this.servers,
          loading: this.isLoading,
          params: {
            children: true,
            filter_methods: {
              filterByMealPeriodDate: [this.mealPeriod.id, this.date]
            }
          }
        },
        {
          command: 'diningGetServerAssignments',
          afterLoad: (r) => {
            this.awaitingApiResponse = false
            this.assignmentsMap = r[0]?.result
          },
          error: (e) => {
            this.awaitingApiResponse = false
            this.errors.push(e.message)
          },
          params: {
            filter_methods: {
              filterData: [this.mealPeriod.id, this.location.id, this.filterMap.serverId ?? null, this.date]
            }
          }
        }
      ]
      this.$ftAPI().get(this.addResourceErrorHandler(commands))
    }
  }
}
</script>